import React from 'react';
import ReactDOM from 'react-dom/client';
import { BrowserRouter } from 'react-router-dom';
import 'bootstrap/dist/css/bootstrap.min.css';
import 'bootstrap-icons/font/bootstrap-icons.css';
import '@fontsource/open-sans/300.css';
import '@fontsource/open-sans/400.css';
import '@fontsource/open-sans/500.css';
import '@fontsource/open-sans/600.css';
import '@fontsource/open-sans/700.css';
import '@fontsource/open-sans/800.css';
import '@fortawesome/fontawesome-free/css/all.min.css';
import './index.css';
import './styles/variables.css';
import './styles/landing-variables.css';
import './styles/global.css';
import './styles/navbar.css';
import './styles/landing.css';
import './styles/home.css';
import './styles/home-enhanced.css';
import './styles/footer.css';
import App from './App';
import reportWebVitals from './reportWebVitals';

// Chrome dispara este "error" cuando ResizeObserver encadena layouts; no indica fallo de la app.
const resizeObserverLoopRe =
  /^ResizeObserver loop (completed with undelivered notifications|limit exceeded)\.?$/i;
window.addEventListener(
  'error',
  (event) => {
    const message = String(event.message || '');
    if (resizeObserverLoopRe.test(message)) {
      event.stopImmediatePropagation();
      return;
    }
    // Iframes cross-origin (p. ej. Mercado Pago Bricks) reportan "Script error." sin detalle.
    if (message === 'Script error.' && !event.filename) {
      event.stopImmediatePropagation();
      event.preventDefault();
    }
  },
  true,
);

const root = ReactDOM.createRoot(document.getElementById('root'));
root.render(
  <React.StrictMode>
    <BrowserRouter>
      <App />
    </BrowserRouter>
  </React.StrictMode>,
);

// If you want to start measuring your web app performance, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
reportWebVitals();
